module.exports = __webpack_public_path__ + "img/adult-primal-merry-jane-purple_1_1.72aa2236.jpg";